// LinkedIn Ads Listen Network - Tactic
// Handles file uploads and form management for this specific tactic

import { createUppyUploader } from '../shared/custom_podpromote_uppy_uploader.js'

document.addEventListener('alpine:init', () => {
  Alpine.data('linkedin_ads_listen_network_x_data', () => ({
    // Form data with safe initialization
    formData: {
      targeting: {
        genders: [],
        age_ranges: [],
        household_incomes: [],
        education_levels: [],
        industries: [],
        business_types: [],
        seniorities: [],
        occupations: [],
        business_locations: [],
        business_scopes: [],
        company_sizes: []
      },
      episodes: [{
        episode_id: '',
        release_date: '',
        apple_link: '',
        spotify_link: ''
      }],
      brand_guidelines_file: null
    },

    // Input variables for text fields
    newOccupation: '',
    newBusinessLocation: '',
    
    init() {
      // Load saved configuration from backend
      this.loadSavedConfiguration();
      
      // Initialize with one episode row by default
      if (this.formData.episodes.length === 0) {
        this.addEpisodeRow();
      }
      
      // Use $nextTick to ensure DOM is fully rendered
      this.$nextTick(() => {
        this.initializeUppyUploader();
        this.initializeEpisodeSelect();
        

        

      });
      
      // Set up cleanup when component is destroyed
      this.$cleanup = () => {
        this.cleanup();
      };
    },

    // Load saved configuration from backend
    loadSavedConfiguration() {
      try {
        const savedDataDiv = this.$refs.savedConfigData;
        
        if (savedDataDiv && savedDataDiv.dataset.savedConfig) {
          const savedConfig = JSON.parse(savedDataDiv.dataset.savedConfig);
          
          if (savedConfig) {
            // Load targeting data
            if (savedConfig.targeting) {
              // Handle both new and old targeting structures
              if (savedConfig.targeting.genders) {
                this.formData.targeting.genders = savedConfig.targeting.genders;
              }
              if (savedConfig.targeting.age_ranges) {
                this.formData.targeting.age_ranges = savedConfig.targeting.age_ranges;
              }
              if (savedConfig.targeting.household_incomes) {
                this.formData.targeting.household_incomes = savedConfig.targeting.household_incomes;
              }
              if (savedConfig.targeting.education_levels) {
                this.formData.targeting.education_levels = savedConfig.targeting.education_levels;
              }
              if (savedConfig.targeting.industries) {
                this.formData.targeting.industries = savedConfig.targeting.industries;
              }
              if (savedConfig.targeting.business_types) {
                this.formData.targeting.business_types = savedConfig.targeting.business_types;
              }
              if (savedConfig.targeting.seniorities) {
                this.formData.targeting.seniorities = savedConfig.targeting.seniorities;
              }
              if (savedConfig.targeting.occupations) {
                this.formData.targeting.occupations = savedConfig.targeting.occupations;
              }
              if (savedConfig.targeting.business_locations) {
                this.formData.targeting.business_locations = savedConfig.targeting.business_locations;
              }
              if (savedConfig.targeting.business_scopes) {
                this.formData.targeting.business_scopes = savedConfig.targeting.business_scopes;
              }
              if (savedConfig.targeting.company_sizes) {
                this.formData.targeting.company_sizes = savedConfig.targeting.company_sizes;
              }
              
              // Also check for old format data
              if (savedConfig.targeting.gender && savedConfig.targeting.gender !== '') {
                this.formData.targeting.genders = [savedConfig.targeting.gender];
              }
              if (savedConfig.targeting.age_range && savedConfig.targeting.age_range !== '') {
                this.formData.targeting.age_ranges = [savedConfig.targeting.age_range];
              }
              if (savedConfig.targeting.household_income && savedConfig.targeting.household_income !== '') {
                this.formData.targeting.household_incomes = [savedConfig.targeting.household_income];
              }
              if (savedConfig.targeting.education_level && savedConfig.targeting.education_level !== '') {
                this.formData.targeting.education_levels = [savedConfig.targeting.education_level];
              }
              if (savedConfig.targeting.industry && savedConfig.targeting.industry !== '') {
                this.formData.targeting.industries = [savedConfig.targeting.industry];
              }
              if (savedConfig.targeting.business_type && savedConfig.targeting.business_type !== '') {
                this.formData.targeting.business_types = [savedConfig.targeting.business_type];
              }
              if (savedConfig.targeting.seniority && savedConfig.targeting.seniority !== '') {
                this.formData.targeting.seniorities = [savedConfig.targeting.seniority];
              }
              if (savedConfig.targeting.occupation && savedConfig.targeting.occupation !== '') {
                this.formData.targeting.occupations = [savedConfig.targeting.occupation];
              }
              if (savedConfig.targeting.business_location && savedConfig.targeting.business_location !== '') {
                this.formData.targeting.business_locations = [savedConfig.targeting.business_location];
              }
              if (savedConfig.targeting.business_scope && savedConfig.targeting.business_scope !== '') {
                this.formData.targeting.business_scopes = [savedConfig.targeting.business_scopes];
              }
              if (savedConfig.targeting.company_size && savedConfig.targeting.company_size !== '') {
                this.formData.targeting.company_sizes = [savedConfig.targeting.company_size];
              }
            }
            
            // Load brand guidelines file data
            if (savedConfig.brand_guidelines_file && savedConfig.brand_guidelines_file.url && savedConfig.brand_guidelines_file.url !== 'unknown') {
              this.formData.brand_guidelines_file = savedConfig.brand_guidelines_file;
              
              // Store file data in hidden input
              const hiddenInput = document.getElementById('brand_guidelines_file');
              if (hiddenInput) {
                hiddenInput.value = JSON.stringify(this.formData.brand_guidelines_file);
              }
              
              // Show upload success status and preview immediately
              // This ensures the file status is displayed on page load
              this.$nextTick(() => {
                this.showUploadSuccess();
              });
            }
            
            // Load episodes data
            if (savedConfig.episodes && savedConfig.episodes.length > 0) {
              // Clear existing episodes and load saved ones
              this.formData.episodes = [];
              
              savedConfig.episodes.forEach((savedEpisode, index) => {
                if (savedEpisode.episode_id) {
                  const newEpisode = {
                    id: `episode_${Date.now()}_${Math.random().toString(36).substr(2, 9)}_${index}`,
                    episode_id: savedEpisode.episode_id,
                    release_date: savedEpisode.release_date || '',
                    apple_link: savedEpisode.apple_link || '',
                    spotify_link: savedEpisode.spotify_link || ''
                  };
                  this.formData.episodes.push(newEpisode);
                }
              });
              
              // Populate episode select dropdowns with saved data
              this.$nextTick(() => {
                setTimeout(() => {
                  this.populateEpisodeSelects();
                }, 100);
              });
            }
          }
        }
      } catch (error) {
        console.error('Error loading saved configuration:', error);
      }
    },

    // Populate episode select dropdowns with saved data
    populateEpisodeSelects() {
      this.formData.episodes.forEach((episode, index) => {
        if (episode.episode_id) {
          const selectElement = document.getElementById(`episode-select-${index}`);
          
          if (selectElement) {
            selectElement.value = episode.episode_id;
          }
        }
      });
    },
    
    // Pill management functions for dropdown fields
    addGender(gender) {
      if (gender && !this.formData.targeting.genders.includes(gender)) {
        this.formData.targeting.genders.push(gender);
        // Reset the select dropdown
        const selectElement = document.querySelector('select[data-gender-select]');
        if (selectElement) selectElement.value = '';
      }
    },

    removeGender(gender) {
      const index = this.formData.targeting.genders.indexOf(gender);
      if (index > -1) {
        this.formData.targeting.genders.splice(index, 1);
      }
    },

    addAgeRange(ageRange) {
      if (ageRange && !this.formData.targeting.age_ranges.includes(ageRange)) {
        this.formData.targeting.age_ranges.push(ageRange);
        // Reset the select dropdown
        const selectElement = document.querySelector('select[data-age-range-select]');
        if (selectElement) selectElement.value = '';
      }
    },

    removeAgeRange(ageRange) {
      const index = this.formData.targeting.age_ranges.indexOf(ageRange);
      if (index > -1) {
        this.formData.targeting.age_ranges.splice(index, 1);
      }
    },

    addHouseholdIncome(income) {
      if (income && !this.formData.targeting.household_incomes.includes(income)) {
        this.formData.targeting.household_incomes.push(income);
        // Reset the select dropdown
        const selectElement = document.querySelector('select[data-household-income-select]');
        if (selectElement) selectElement.value = '';
      }
    },

    removeHouseholdIncome(income) {
      const index = this.formData.targeting.household_incomes.indexOf(income);
      if (index > -1) {
        this.formData.targeting.household_incomes.splice(index, 1);
      }
    },

    addEducationLevel(educationLevel) {
      if (educationLevel && !this.formData.targeting.education_levels.includes(educationLevel)) {
        this.formData.targeting.education_levels.push(educationLevel);
        // Reset the select dropdown
        const selectElement = document.querySelector('select[data-education-level-select]');
        if (selectElement) selectElement.value = '';
      }
    },

    removeEducationLevel(educationLevel) {
      const index = this.formData.targeting.education_levels.indexOf(educationLevel);
      if (index > -1) {
        this.formData.targeting.education_levels.splice(index, 1);
      }
    },

    addIndustry(industry) {
      if (industry && !this.formData.targeting.industries.includes(industry)) {
        this.formData.targeting.industries.push(industry);
        // Reset the select dropdown
        const selectElement = document.querySelector('select[data-industry-select]');
        if (selectElement) selectElement.value = '';
      }
    },

    removeIndustry(industry) {
      const index = this.formData.targeting.industries.indexOf(industry);
      if (index > -1) {
        this.formData.targeting.industries.splice(index, 1);
      }
    },

    addBusinessType(businessType) {
      if (businessType && !this.formData.targeting.business_types.includes(businessType)) {
        this.formData.targeting.business_types.push(businessType);
        // Reset the select dropdown
        const selectElement = document.querySelector('select[data-business-type-select]');
        if (selectElement) selectElement.value = '';
      }
    },

    removeBusinessType(businessType) {
      const index = this.formData.targeting.business_types.indexOf(businessType);
      if (index > -1) {
        this.formData.targeting.business_types.splice(index, 1);
      }
    },

    addSeniority(seniority) {
      if (seniority && !this.formData.targeting.seniorities.includes(seniority)) {
        this.formData.targeting.seniorities.push(seniority);
        // Reset the select dropdown
        const selectElement = document.querySelector('select[data-seniority-select]');
        if (selectElement) selectElement.value = '';
      }
    },

    removeSeniority(seniority) {
      const index = this.formData.targeting.seniorities.indexOf(seniority);
      if (index > -1) {
        this.formData.targeting.seniorities.splice(index, 1);
      }
    },

    addBusinessScope(scope) {
      if (scope && !this.formData.targeting.business_scopes.includes(scope)) {
        this.formData.targeting.business_scopes.push(scope);
        // Reset the select dropdown
        const selectElement = document.querySelector('select[data-business-scope-select]');
        if (selectElement) selectElement.value = '';
      }
    },

    removeBusinessScope(scope) {
      const index = this.formData.targeting.business_scopes.indexOf(scope);
      if (index > -1) {
        this.formData.targeting.business_scopes.splice(index, 1);
      }
    },

    addCompanySize(size) {
      if (size && !this.formData.targeting.company_sizes.includes(size)) {
        this.formData.targeting.company_sizes.push(size);
        // Reset the select dropdown
        const selectElement = document.querySelector('select[data-company-size-select]');
        if (selectElement) selectElement.value = '';
      }
    },

    removeCompanySize(size) {
      const index = this.formData.targeting.company_sizes.indexOf(size);
      if (index > -1) {
        this.formData.targeting.company_sizes.splice(index, 1);
      }
    },

    // Pill management functions for text input fields
    addOccupation() {
      if (this.newOccupation && this.newOccupation.trim()) {
        const occupation = this.formatTextInput(this.newOccupation.trim());
        if (occupation && !this.formData.targeting.occupations.includes(occupation)) {
          this.formData.targeting.occupations.push(occupation);
        }
        this.newOccupation = '';
      }
    },

    removeOccupation(occupation) {
      const index = this.formData.targeting.occupations.indexOf(occupation);
      if (index > -1) {
        this.formData.targeting.occupations.splice(index, 1);
      }
    },

    addBusinessLocation() {
      if (this.newBusinessLocation && this.newBusinessLocation.trim()) {
        const location = this.formatTextInput(this.newBusinessLocation.trim());
        if (location && !this.formData.targeting.business_locations.includes(location)) {
          this.formData.targeting.business_locations.push(location);
        }
        this.newBusinessLocation = '';
      }
    },

    removeBusinessLocation(location) {
      const index = this.formData.targeting.business_locations.indexOf(location);
      if (index > -1) {
        this.formData.targeting.business_locations.splice(index, 1);
      }
    },

    // Format text input: only allow letters, numbers, hyphens, and spaces between words
    formatTextInput(text) {
      return text
        .replace(/[^a-zA-Z0-9\s-]/g, '') // Remove special characters except letters, numbers, spaces, and hyphens
        .replace(/^[\s-]+|[\s-]+$/g, '') // Remove leading/trailing spaces and hyphens
        .replace(/[\s-]+/g, ' ') // Replace multiple spaces/hyphens with single space
        .replace(/\s+/g, ' ') // Replace multiple spaces with single space
        .trim();
    },
    
    // Get display text for targeting values
    getDisplayText(value, type) {
      if (!value) return '';
      
      // Load targeting mappings from backend data
      const targetingMappingsElement = this.$el.closest('[data-targeting-mappings]');
      const mappings = targetingMappingsElement ? 
        JSON.parse(targetingMappingsElement.dataset.targetingMappings || '{}') : {};
      
      return mappings[type]?.[value] || value;
    },

    initializeUppyUploader() {
      // Check if Uppy uploader is already initialized
      if (window.uppyInstances && window.uppyInstances['linkedin-ads-brand-guidelines-uploader']) {
        return;
      }
      
      try {
        // Get show ID and campaign ID from URL
        const showId = this.getShowId();
        const campaignId = this.getCampaignId();
        
        if (!showId) {
          console.error('Show ID not found');
          return;
        }
        
        if (!campaignId) {
          console.error('Campaign ID not found');
          return;
        }

        // Initialize Uppy uploader using the modular approach
        const uppyInstance = createUppyUploader({
          id: 'linkedin-ads-brand-guidelines-uploader',
          show_id: showId,
          campaign_id: campaignId,
          campaign_tactic_id: this.getCampaignTacticId(),
          trigger_id: '#brand-guidelines-upload-trigger',
          max_file_size: 100 * 1024 * 1024, // 100MB
          allowed_file_types: [
            'application/pdf',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/vnd.ms-powerpoint',
            'application/vnd.openxmlformats-officedocument.presentationml.presentation'
          ],
          max_number_of_files: 1,
          auto_proceed: true,
          close_after_finish: true,
          note: 'Accepted files: PDF, DOC, DOCX, PPT, PPTX. Maximum size: 100MB.',
          on_complete: (result) => {
            this.handleUploadComplete(result);
          },
          on_error: (file, error, response) => {
            this.handleUploadError(file, error, response);
          },
          alpine: this // Pass Alpine instance for callbacks
        });
        
        // Store the instance globally to prevent re-initialization
        if (!window.uppyInstances) {
          window.uppyInstances = {};
        }
        window.uppyInstances['linkedin-ads-brand-guidelines-uploader'] = uppyInstance;
        
      } catch (error) {
        console.error('Failed to initialize Uppy uploader:', error);
      }
    },
    
    // Cleanup function to dispose of Uppy instance
    cleanup() {
      try {
        if (window.uppyInstances && window.uppyInstances['linkedin-ads-brand-guidelines-uploader']) {
          const uppyInstance = window.uppyInstances['linkedin-ads-brand-guidelines-uploader'];
          
          // Clean up the Uppy instance
          if (uppyInstance && typeof uppyInstance.close === 'function') {
            uppyInstance.close();
          }
          
          // Remove from global registry
          delete window.uppyInstances['linkedin-ads-brand-guidelines-uploader'];
        }
      } catch (error) {
        console.error('Error during Uppy cleanup:', error);
      }
    },
    
    getShowId() {
      const urlParts = window.location.pathname.split('/');
      const showIndex = urlParts.indexOf('shows');
      if (showIndex !== -1 && showIndex + 1 < urlParts.length) {
        return urlParts[showIndex + 1];
      }
      return null;
    },

    getCampaignId() {
      const urlParts = window.location.pathname.split('/');
      const campaignIndex = urlParts.indexOf('campaigns');
      if (campaignIndex !== -1 && campaignIndex + 1 < urlParts.length) {
        return urlParts[campaignIndex + 1];
      }
      return null;
    },
    
    getCampaignTacticId() {
      // Try to get from the routes div first
      const routesDiv = this.$refs.routes;
      if (routesDiv && routesDiv.dataset.campaignTacticId) {
        return routesDiv.dataset.campaignTacticId;
      }
      
      // Fallback to URL parsing if needed
      const urlParts = window.location.pathname.split('/');
      const tacticIndex = urlParts.indexOf('campaign-tactics');
      if (tacticIndex !== -1 && tacticIndex + 1 < urlParts.length) {
        return urlParts[tacticIndex + 1];
      }
      
      return null;
    },
    
    handleUploadComplete(result) {
      if (result.successful && result.successful.length > 0) {
        const file = result.successful[0];
        
        // Safety check for this context
        if (!this || !this.formData) {
          return;
        }
        
        // Parse the response to get the S3 data
        let responseData;
        try {
          if (file.response && file.response.body) {
            responseData = typeof file.response.body === 'string' ? JSON.parse(file.response.body) : file.response.body;
          } else if (file.response) {
            responseData = file.response;
          } else {
            responseData = {};
          }
        } catch (e) {
          responseData = file.response || {};
        }
        
        // Extract S3 data from response - try multiple possible keys
        const s3Key = responseData?.key || responseData?.s3_key || responseData?.file_key || 'unknown';
        const s3Url = responseData?.uploadURL || responseData?.url || responseData?.s3_url || responseData?.file_url || responseData?.download_url || 'unknown';
        
        // Update the formData with the new file information
        this.formData.brand_guidelines_file = {
          name: file.name,
          size: file.size,
          type: file.type,
          s3_key: s3Key,
          url: s3Url
        };
        
        // Store file data in window object for form submission
        window.linkedinAdsBrandGuidelinesFile = this.formData.brand_guidelines_file;
        
        // Store file data in hidden input
        const hiddenInput = document.getElementById('brand_guidelines_file');
        if (hiddenInput) {
          hiddenInput.value = JSON.stringify(this.formData.brand_guidelines_file);
        }
        
        // Show success message
        this.showUploadSuccess();
      } else if (result.failed && result.failed.length > 0) {
        // Handle failed uploads
        const failedFile = result.failed[0];
        if (failedFile && failedFile.error) {
          this.handleUploadError(failedFile, failedFile.error, failedFile.response);
        }
      }
    },
    
    handleUploadError(file, error, response) {
      // Show alert for all validation errors
      let errorMessage = error.message || 'Unknown error occurred';
      
      if (error.message && error.message.includes('size')) {
        errorMessage = `File Size Error: ${error.message}\n\nPlease upload a file smaller than 100MB.`;
      } else if (error.message && error.message.includes('type')) {
        errorMessage = `File Type Error: ${error.message}\n\nPlease upload a PDF, DOC, DOCX, PPT, or PPTX file.`;
      }
      
      alert(errorMessage);
      this.showUploadError(error.message || 'Upload failed');
    },
    
    showUploadError(message) {
      console.error('Upload error:', message);
    },
    
    // Episode management
    addEpisodeRow() {
      if (this.formData.episodes.length >= 5) {
        alert('Maximum of 5 episodes allowed');
        return;
      }
      
      const newEpisode = {
        episode_id: '',
        release_date: '',
        apple_link: '',
        spotify_link: ''
      };
      
      this.formData.episodes.push(newEpisode);
      
      // Initialize event listeners for the new row
      this.$nextTick(() => {
        this.initializeEpisodeSelect();
      });
    },

    removeEpisodeRow(episodeIndex) {
      // Don't allow removing the last episode row
      if (this.formData.episodes.length <= 1) {
        return;
      }
      
      // Remove the episode from the array by index
      this.formData.episodes.splice(episodeIndex, 1);
      
      // Reinitialize event listeners after removing a row
      this.$nextTick(() => {
        this.initializeEpisodeSelect();
      });
    },

    // Initialize episode select event listeners
    initializeEpisodeSelect() {
      this.$nextTick(() => {
        this.formData.episodes.forEach((episode, index) => {
          const selectElement = document.getElementById(`episode-select-${index}`);
          if (selectElement) {
            // Remove existing event listeners to prevent duplicates
            selectElement.removeEventListener('change', this.createEpisodeChangeHandler(index));
            // Add new event listener
            selectElement.addEventListener('change', this.createEpisodeChangeHandler(index));
          }
        });
      });
    },

    // Create a change handler for a specific episode select
    createEpisodeChangeHandler(episodeIndex) {
      return (event) => {
        const selectedEpisodeId = event.target.value;
        
        if (selectedEpisodeId) {
          this.handleEpisodeSelection(selectedEpisodeId, episodeIndex);
        }
      };
    },

    handleEpisodeSelection(episodeId, index) {
      if (episodeId && this.formData.episodes[index]) {
        // Check if this episode is already selected in another row
        const isDuplicate = this.formData.episodes.some((episode, episodeIndex) => 
          episodeIndex !== index && episode.episode_id === episodeId
        );
        
        if (isDuplicate) {
          alert('This episode is already selected in another row. Please choose a different episode.');
          // Reset the select dropdown to empty
          const selectElement = document.getElementById(`episode-select-${index}`);
          if (selectElement) {
            selectElement.value = '';
          }
          return;
        }
        
        this.formData.episodes[index].episode_id = episodeId;
        
        // Find the selected episode data from the backend episodes
        const selectedEpisode = this.findEpisodeById(episodeId);
        
        if (selectedEpisode) {
          // Handle pub_date
          if (selectedEpisode.pub_date) {
            const formattedDate = this.formatDate(selectedEpisode.pub_date);
            this.formData.episodes[index].release_date = formattedDate;
          } else {
            this.formData.episodes[index].release_date = 'Release date not available';
          }
          
          // Handle distribution platforms (Apple and Spotify links)
          if (selectedEpisode.distribution_platforms) {
            const platforms = selectedEpisode.distribution_platforms;
            
            // Set Apple link using itunes_url key
            if (platforms.itunes_url) {
              this.formData.episodes[index].apple_link = platforms.itunes_url;
            } else {
              this.formData.episodes[index].apple_link = '';
            }
            
            // Set Spotify link using spotify_url key
            if (platforms.spotify_url) {
              this.formData.episodes[index].spotify_link = platforms.spotify_url;
            } else {
              this.formData.episodes[index].spotify_link = '';
            }
          } else {
            this.formData.episodes[index].apple_link = '';
            this.formData.episodes[index].spotify_link = '';
          }
        }
      }
    },

    // Find episode by ID from the backend data
    findEpisodeById(episodeId) {
      // Get episodes data from the global window object
      let episodesData = window.episodesData || [];
      
      if (!episodesData || episodesData.length === 0) {
        return null;
      }
      
      return episodesData.find(episode => episode.id == episodeId);
    },

    // Format date for display
    formatDate(dateString) {
      if (!dateString) return 'Date not available';
      
      try {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return 'Invalid date';
        
        return date.toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        });
      } catch (error) {
        console.error('Error formatting date:', error);
        return 'Date not available';
      }
    },


    // Check if file is uploaded by checking window object or DOM
    hasFileUploaded() {
      // First check window object (most reliable)
      if (window.linkedinAdsBrandGuidelinesFile && window.linkedinAdsBrandGuidelinesFile.url && window.linkedinAdsBrandGuidelinesFile.url !== 'unknown') {
        return true;
      }
      
      // Fallback to DOM check
      const hiddenInput = document.getElementById('brand_guidelines_file');
      if (hiddenInput && hiddenInput.value) {
        try {
          const fileData = JSON.parse(hiddenInput.value);
          return fileData && fileData.url && fileData.url !== 'unknown';
        } catch (e) {
          return false;
        }
      }
      return false;
    },

    // Clear uploaded file data
    clearFileData() {
      this.formData.brand_guidelines_file = null;
      window.linkedinAdsBrandGuidelinesFile = null;
      
      const hiddenInput = document.getElementById('brand_guidelines_file');
      if (hiddenInput) {
        hiddenInput.value = '';
      }
      
      // Hide upload status and preview
      const statusElement = document.getElementById('brand-guidelines-upload-status');
      const previewElement = document.getElementById('brand-guidelines-preview');
      if (statusElement) statusElement.classList.add('hidden');
      if (previewElement) previewElement.classList.add('hidden');
    },
    
    // Show upload success status
    showUploadSuccess() {
      // Show success message to user
      const statusElement = document.getElementById('brand-guidelines-upload-status');
      const previewElement = document.getElementById('brand-guidelines-preview');
      const fileNameElement = document.getElementById('uploaded-file-name');
      
      // Ensure we have the file data
      if (!this.formData.brand_guidelines_file) {
        return;
      }
      
      if (statusElement) {
        statusElement.classList.remove('hidden');
        
        const messageElement = statusElement.querySelector('span');
        
        if (messageElement) {
          const successMessage = `${this.formData.brand_guidelines_file.name} uploaded successfully`;
          messageElement.textContent = successMessage;
        }
        
        // Ensure icon is green
        const iconElement = statusElement.querySelector('svg');
        if (iconElement) {
          iconElement.classList.remove('text-red-500');
          iconElement.classList.add('text-green-500');
        }
      }
      
      // Show file preview section
      if (previewElement && fileNameElement) {
        previewElement.classList.remove('hidden');
        fileNameElement.textContent = this.formData.brand_guidelines_file.name;
      }
      

    },
    

    


    // Save form configuration
    saveForm() {
      try {
        // Check if brand guidelines file is uploaded and valid FIRST
        if (!this.hasFileUploaded()) {
          alert('Please upload a brand guidelines file.');
          return;
        }
        
        // Validation for targeting fields
        if (this.formData.targeting.genders.length === 0) {
          alert('Please add at least one gender for targeting.');
          return;
        }
        
        if (this.formData.targeting.age_ranges.length === 0) {
          alert('Please add at least one age range for targeting.');
          return;
        }
        
        if (this.formData.targeting.household_incomes.length === 0) {
          alert('Please add at least one household income range for targeting.');
          return;
        }
        
        if (this.formData.targeting.education_levels.length === 0) {
          alert('Please add at least one education level for targeting.');
          return;
        }
        
        if (this.formData.targeting.industries.length === 0) {
          alert('Please add at least one industry for targeting.');
          return;
        }
        
        if (this.formData.targeting.business_types.length === 0) {
          alert('Please add at least one business type for targeting.');
          return;
        }
        
        if (this.formData.targeting.seniorities.length === 0) {
          alert('Please add at least one seniority level for targeting.');
          return;
        }
        
        if (this.formData.targeting.business_locations.length === 0) {
          alert('Please add at least one business location for targeting.');
          return;
        }
        
        if (this.formData.episodes.length === 0 || this.formData.episodes.every(ep => !ep.episode_id)) {
          alert('Please select at least one episode to highlight.');
          return;
        }
        
        // Check for duplicate episodes
        const episodeIds = this.formData.episodes
          .filter(ep => ep.episode_id)
          .map(ep => ep.episode_id);
        
        const uniqueEpisodeIds = [...new Set(episodeIds)];
        
        if (episodeIds.length !== uniqueEpisodeIds.length) {
          alert('Duplicate episodes detected. Please ensure each episode is selected only once.');
          return;
        }
        
        // Prepare data for submission
        const formDataToSubmit = {
          targeting: {
            genders: this.formData.targeting.genders,
            age_ranges: this.formData.targeting.age_ranges,
            household_incomes: this.formData.targeting.household_incomes,
            education_levels: this.formData.targeting.education_levels,
            industries: this.formData.targeting.industries,
            business_types: this.formData.targeting.business_types,
            seniorities: this.formData.targeting.seniorities,
            occupations: this.formData.targeting.occupations,
            business_locations: this.formData.targeting.business_locations,
            business_scopes: this.formData.targeting.business_scopes,
            company_sizes: this.formData.targeting.company_sizes
          },
          episodes: this.formData.episodes.filter(ep => ep.episode_id).map(ep => ({
            episode_id: ep.episode_id,
            release_date: ep.release_date,
            apple_link: ep.apple_link,
            spotify_link: ep.spotify_link
          })),
          brand_guidelines_file: this.formData.brand_guidelines_file || {}
        };
        
        // Get brand guidelines file from window object or formData
        if (window.linkedinAdsBrandGuidelinesFile && window.linkedinAdsBrandGuidelinesFile.url) {
          formDataToSubmit.brand_guidelines_file = window.linkedinAdsBrandGuidelinesFile;
        } else if (this.formData.brand_guidelines_file && this.formData.brand_guidelines_file.url) {
          formDataToSubmit.brand_guidelines_file = this.formData.brand_guidelines_file;
        } else {
          formDataToSubmit.brand_guidelines_file = {};
        }
        

        
        // Get the submit link from the routes template
        const routesTemplate = this.$refs.routes;
        const submitLink = routesTemplate?.dataset?.submitLink;
        
        if (!submitLink) {
          alert('Submit link not found. Please refresh the page and try again.');
          return;
        }
        
        // Create a hidden form and submit it
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = submitLink;
        
        // Add CSRF token
        const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
        if (csrfToken) {
          const csrfInput = document.createElement('input');
          csrfInput.type = 'hidden';
          csrfInput.name = 'authenticity_token';
          csrfInput.value = csrfToken;
          form.appendChild(csrfInput);
        }
        
        // Add method override for PATCH
        const methodInput = document.createElement('input');
        methodInput.type = 'hidden';
        methodInput.name = '_method';
        methodInput.value = 'PATCH';
        form.appendChild(methodInput);
        
        // Add form data as JSON
        const formDataInput = document.createElement('input');
        formDataInput.type = 'hidden';
        formDataInput.name = 'form_data';
        formDataInput.value = JSON.stringify(formDataToSubmit);
        form.appendChild(formDataInput);
        
        // Add to DOM and submit
        document.body.appendChild(form);
        form.submit();
      } catch (error) {
        alert('Error saving configuration. Please try again.');
      }
    },

    // Save as draft (no validations)
    saveAsDraft() {
        // Prepare data for submission (same as saveForm but without validations)
        const formDataToSubmit = {
          targeting: {
            genders: this.formData.targeting.genders,
            age_ranges: this.formData.targeting.age_ranges,
            household_incomes: this.formData.targeting.household_incomes,
            education_levels: this.formData.targeting.education_levels,
            industries: this.formData.targeting.industries,
            business_types: this.formData.targeting.business_types,
            seniorities: this.formData.targeting.seniorities,
            occupations: this.formData.targeting.occupations,
            business_locations: this.formData.targeting.business_locations,
            business_scopes: this.formData.targeting.business_scopes,
            company_sizes: this.formData.targeting.company_sizes
          },
          episodes: this.formData.episodes.filter(ep => ep.episode_id).map(ep => ({
            episode_id: ep.episode_id,
            release_date: ep.release_date,
            apple_link: ep.apple_link,
            spotify_link: ep.spotify_link
          })),
          brand_guidelines_file: this.formData.brand_guidelines_file || {}
        };
        
        // Get brand guidelines file from window object or formData
        if (window.linkedinAdsBrandGuidelinesFile && window.linkedinAdsBrandGuidelinesFile.url) {
          formDataToSubmit.brand_guidelines_file = window.linkedinAdsBrandGuidelinesFile;
        } else if (this.formData.brand_guidelines_file && this.formData.brand_guidelines_file.url) {
          formDataToSubmit.brand_guidelines_file = this.formData.brand_guidelines_file;
        } else {
          formDataToSubmit.brand_guidelines_file = {};
        }
        
        // Get the save as draft link from the routes template
        const routesTemplate = this.$refs.routes;
        const saveAsDraftLink = routesTemplate?.dataset?.saveAsDraftLink;
        
        // Create a hidden form and submit it
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = saveAsDraftLink;
        form.style.display = 'none';
        
        // Add CSRF token
        const csrfInput = document.createElement('input');
        csrfInput.type = 'hidden';
        csrfInput.name = 'authenticity_token';
        csrfInput.value = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '';
        form.appendChild(csrfInput);
        
        // Add method override for PATCH
        const methodInput = document.createElement('input');
        methodInput.type = 'hidden';
        methodInput.name = '_method';
        methodInput.value = 'patch';
        form.appendChild(methodInput);
        
        // Add form data
        const formDataInput = document.createElement('input');
        formDataInput.type = 'hidden';
        formDataInput.name = 'form_data';
        formDataInput.value = JSON.stringify(formDataToSubmit);
        form.appendChild(formDataInput);
        
        // Add to DOM and submit
        document.body.appendChild(form);
        form.submit();
    }
  }));
});
